import ReactDOM from "react-dom";
import BaseComponent from "../../../baseComponent.js";
import Chart from "../../widgets/timeseries-chart/chart.jsx";
import Tooltip from "../../widgets/timeseries-chart/tooltip/tooltip.jsx";
import InternalEvent from "../../../../core/constants/internalEvent.js";
import WidgetType from "../../../../core/constants/widgetType.js";

export default class TimeSeries extends BaseComponent {
  constructor(props) {
    super(props);
    this.tooltipId = "tooltip-" + this.props.model.id;
  }

  componentDidMount() {
    var _this = this;
    $("#tooltips-container").append("<div id=" + this.tooltipId + "></div>");
    ReactDOM.render(<Tooltip widgetId={this.props.model.id}
                             metaData={this.props.metaData}/>, document.getElementById(this.tooltipId));
    this.subscribe(InternalEvent.Widget.HISTORY_MODE_TOGGLED, function (data) {
      if (data.widgetId === _this.props.model.id && data.value != null) {
        $(_this.refs.resumeRealtimeBtn).addClass("wrapper-icon").stop().fadeIn().css({
          background: "rgba(255, 255, 255, 0.9)"
        });
      } else {
        $(_this.refs.resumeRealtimeBtn).removeClass("wrapper-icon").stop().fadeOut();
      }
    });

    $(this.refs.resumeRealtimeBtn).on("click", this.onRealtimeResumeButtonClick);
  }

  componentWillUnmount() {
    ReactDOM.unmountComponentAtNode(document.getElementById(this.tooltipId));
    this.unsubscribeAll();
  }

  onRealtimeResumeButtonClick() {
    this.publish(InternalEvent.Subscription.CHART_RESET, {
      widgetId: this.props.model.id,
      type: this.props.model.type,
      components: this.props.components,
      title: this.props.model.title,
      legends: this.props.model.legends,
      maximized: false
    });
    $(this.refs.resumeRealtimeBtn).css('display', 'none');
  }

  render() {
    let component;
    for (let componentId in this.props.components) {
      component = this.props.components[componentId];
    }

    // preview widget uses tooltip container in the databank component due to positioning problem
    const tooltip = this.props.isPreviewWidget ? null : <div id="tooltips-container"/>;

    const resumeBtnStyle = {
      right: '32px',
      position: 'absolute',
      color: 'rgb(93, 140, 227)',
      top: '24px',
      fontSize: '18px',
      cursor: 'pointer',
      zIndex: '100000',
      display: 'none'
    };

    return (
      <div className="widget-container" style={{height: "100%", width: "100%"}}>
        <i className="icon-control-play chart-widget-play-btn"
           ref="resumeRealtimeBtn" style={resumeBtnStyle}/>
        <Chart widget={this.props.widget} widgetId={this.props.model.id}
               isVertical={this.props.widget.type === WidgetType.TIME_SERIES_VERTICAL}
               componentModel={component}
               legends={this.props.model.legends}
               isAddOrEditWidget={true}
               metaData={this.props.metaData || {}}/>
        {tooltip}
      </div>
    );
  }

}


// WEBPACK FOOTER //
// ./src/components/dashboard/add-widget/widgets/timeSeries.jsx